module.exports = __webpack_public_path__ + "img/5.8f5590f6.jpg";